import { CheckResultListItem } from "./check-result-list-item";
import { ArrayHelper } from "../helper/array-helper";
import { CheckResult } from "./checkresult";

export const enum ResultLevel {
	None = 0,
	Ok = 1,
	Info = 2,
	Warning = 4,
	Error = 8,
	Fatal = 16
}

export class CheckResultData<T = any> {
	public static isCheckResultData(item: any): item is CheckResultData {
		return item
			&& "success" in item
			&& "highestLevel" in item
			&& "resultData" in item;
	}

	public static fromPlainObject(item: CheckResultData) {
		return $.extend(new CheckResultData(), item);
	}

	public static mergeResultData(items: CheckResultData[]): CheckResultData {
		let newCheckResultData = new CheckResultData();
		if (!items || items.length === 0) {
			return newCheckResultData;
		}

		let errorLists = items.map((item) => item.errorList || []);
		let checkResultLists = items.map((item) => item.checkResultList || []);
		newCheckResultData.errorList = [].concat(...errorLists);
		newCheckResultData.checkResultList = [].concat(...checkResultLists);
		newCheckResultData.highestLevel = ArrayHelper.max({ source: items, key: "highestLevel" });
		newCheckResultData.success = items.every((item) => item.success);
		return newCheckResultData;
	}

	public error: any;
	public errorList: string[] = [];
	public success: boolean = true;
	public highestLevel: ResultLevel = ResultLevel.None;
	public checkResultList: CheckResultListItem[] = [];
	public resultData: T;
	public resultTime: Date;
	public title: string = "Validierungsfehler";
	public exception: string;

	public addError(text: string, group: string = "Validierung", atTheEnd: boolean = true) {
		this.addItem(text, ResultLevel.Error, group, atTheEnd);
	}
	public addWarning(text: string, group: string = "Validierung", atTheEnd: boolean = true) {
		this.addItem(text, ResultLevel.Warning, group, atTheEnd);
	}
	public addInfo(text: string, group: string = "Validierung", atTheEnd: boolean = true) {
		this.addItem(text, ResultLevel.Info, group, atTheEnd);
	}

	public addOk(text: string, group: string = "Validierung", atTheEnd: boolean = true) {
		this.addItem(text, ResultLevel.Ok, group, atTheEnd);
	}

	private addItem(text: string, resultLevel: number = ResultLevel.Warning, group: string = "Validierung", atTheEnd: boolean) {
		let insert = atTheEnd ? Array.prototype.push : Array.prototype.unshift;

		let groupItem = this.checkResultList.find((val) => val && val.text === group);
		if (!groupItem) {
			groupItem = new CheckResultListItem(group, resultLevel, true);
			insert.call(this.checkResultList, groupItem);
		}

		insert.call(groupItem.items, new CheckResult(text, resultLevel));

		if (groupItem.resultLevel < resultLevel) {
			groupItem.resultLevel = resultLevel;
		}

		if (this.highestLevel < groupItem.resultLevel) {
			this.highestLevel = groupItem.resultLevel;
			this.success = this.highestLevel < ResultLevel.Error;
		}
	}
}